var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkTypeCategoryDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2549 0 48 10.7452 48 24C48 37.2549 37.2549 48 24 48C10.7452 48 0 37.2549 0 24Z",
    fill: "url(#paint0_linear_5_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7795 15.6616C27.4083 15.8712 27.748 16.5507 27.5385 17.1795L22.7385 31.5795C22.5289 32.2081 21.8493 32.548 21.2206 32.3383C20.5918 32.1288 20.2521 31.4493 20.4616 30.8205L25.2616 16.4205C25.4712 15.7918 26.1508 15.4519 26.7795 15.6616ZM18.8485 19.5514C19.3173 20.02 19.3173 20.7799 18.8485 21.2485L16.0971 24L18.8485 26.7514C19.3173 27.22 19.3173 27.9799 18.8485 28.4485C18.3799 28.9171 17.6202 28.9171 17.1516 28.4485L13.5515 24.8485C13.0829 24.3799 13.0829 23.62 13.5515 23.1514L17.1516 19.5514C17.6202 19.0828 18.3799 19.0828 18.8485 19.5514ZM29.1516 19.5514C29.6202 19.0828 30.3799 19.0828 30.8485 19.5514L34.4485 23.1514C34.9173 23.62 34.9173 24.3799 34.4485 24.8485L30.8485 28.4485C30.3799 28.9171 29.6202 28.9171 29.1516 28.4485C28.6828 27.9799 28.6828 27.22 29.1516 26.7514L31.903 24L29.1516 21.2485C28.6828 20.7799 28.6828 20.02 29.1516 19.5514Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_5",
    x1: -2.22933e-7,
    y1: 35.76,
    x2: 49.4434,
    y2: 31.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkTypeCategoryDesign);
export default __webpack_public_path__ + "static/media/work-type-category-design.aa3e0eb7a77a3c323749d3deed0b9ac5.svg";
export { ForwardRef as ReactComponent };